module.exports = __webpack_public_path__ + "src/assets/images/ic_x.svg?d3149b01e0c1a8fe253418e810d6e0ca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_x.svg
// module id = 998
// module chunks = 1